import {
    COST_CENTRE_BUSY,
    COST_CENTRE_ERROR,
    COST_CENTRE_RETRIEVED,
} from '../constants/actions';

import {
    addExecuteQuery,
} from 'ntnu-react/util/sp';

export function getCostCenters() {
    return (dispatch) => {
        dispatch({ type: COST_CENTRE_BUSY });
        if(__DEV__) {
            return dispatch({
                type: COST_CENTRE_RETRIEVED,
                payload: require('../mock/costCenters.json'),
            });
        }

        window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
            window.SP.SOD.registerSod('sp.taxonomy.js', window.SP.Utilities.Utility.getLayoutsPageUrl('sp.taxonomy.js'));
            window.SP.SOD.executeFunc('sp.taxonomy.js', false, Function.createDelegate(this, function () {
                const ctx = window.SP.ClientContext.get_current();
                const taxSession = window.SP.Taxonomy.TaxonomySession.getTaxonomySession(ctx);
                const termStores = taxSession.get_termStores();
                const termStore = termStores.getByName("Taxonomy_gDEyvD+7z7yw1UIiW72syA==");
                const termSet = termStore.getTermSet("ad61a6c6-7c14-4f10-b6b6-4bfbf1856ccd");
                const terms = termSet.getAllTerms();
                addExecuteQuery();
                ctx.load(terms);
                ctx.executeQuery()
                .then(() => {
                    const enumerator = terms.getEnumerator();
                    const result = [];
                    while(enumerator.moveNext()) {
                        const currTerm = enumerator.get_current();
                        result.push({key: currTerm.get_id().toString(), text: currTerm.get_name()});
                    }
                    return dispatch( {
                        type: COST_CENTRE_RETRIEVED,
                        payload: result,
                    });
                })
                .catch((sender, args) => {
                    return dispatch({
                        type: COST_CENTRE_ERROR,
                        payload: `Error loading drop down ${args && args.get_message() || ''}`,
                    });
                });
            }));
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/costCenterAction.js